import LegalPage from "../components/LegalPage";

export default function CookiesPolicyPage() {
  return (
    <LegalPage title="Politique de Cookies" lastUpdated="30 octobre 2026">
      <p>Cette politique explique comment <strong>Lokaso</strong> (lokasos.com) utilise les cookies et technologies similaires lorsque vous visitez notre plateforme. Elle vous explique ce que sont ces technologies, pourquoi nous les utilisons, et vos droits pour en contrôler l'utilisation.</p>

      <h2>1. Qu'est-ce qu'un Cookie ?</h2>
      <p>Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, téléphone, tablette) lorsque vous visitez un site web. Il permet au site de mémoriser vos actions et préférences sur une période donnée, afin que vous n'ayez pas à les ressaisir à chaque visite.</p>

      <h2>2. Types de Cookies Utilisés par Lokaso</h2>
      <h3>2.1 Cookies strictement nécessaires</h3>
      <p>Indispensables au fonctionnement de la plateforme. Ils ne peuvent pas être désactivés.</p>
      <ul>
        <li><strong>Cookie de session</strong> (session_id) : maintient votre connexion pendant votre visite — Durée : session</li>
        <li><strong>Cookie d'authentification JWT</strong> : permet de rester connecté à votre compte — Durée : 7 jours</li>
        <li><strong>Préférences techniques</strong> (localStorage) : mémorise vos paramètres d'affichage — Durée : permanente jusqu'à effacement</li>
      </ul>
      <h3>2.2 Cookies analytiques (Google Analytics 4)</h3>
      <p>Ces cookies nous aident à comprendre comment les visiteurs utilisent Lokaso. Toutes les données sont anonymisées — nous ne pouvons pas vous identifier personnellement via ces cookies.</p>
      <ul>
        <li><strong>_ga</strong> : identifiant unique anonyme pour distinguer les utilisateurs — Durée : 2 ans</li>
        <li><strong>_ga_XXXXXXXX</strong> : état de la session GA4 — Durée : 2 ans</li>
        <li><strong>_gid</strong> : distinction des utilisateurs sur 24h — Durée : 24 heures</li>
      </ul>
      <p>Configuration de confidentialité appliquée : <code>anonymize_ip</code> activé, données partagées avec Google Ireland Limited.</p>
      <h3>2.3 Cookies de consentement</h3>
      <ul>
        <li><strong>cc_cookie</strong> : mémorise vos préférences de consentement cookies (vanilla-cookieconsent v3, self-hosted, open source MIT) — Durée : 6 mois</li>
      </ul>

      <h2>3. Ce que Nous Ne Faisons PAS</h2>
      <ul>
        <li>Nous ne vendons jamais vos données de cookies à des tiers</li>
        <li>Nous n'utilisons pas de cookies publicitaires ou de tracking comportemental</li>
        <li>Nous n'utilisons pas de cookies de réseaux sociaux (Facebook Pixel, etc.)</li>
        <li>Nous ne combinons pas vos données de cookies avec des données personnelles identifiantes</li>
      </ul>

      <h2>4. Technologies Similaires</h2>
      <h3>4.1 LocalStorage</h3>
      <p>Lokaso utilise le LocalStorage du navigateur pour stocker vos préférences d'affichage (langue, filtres de recherche récents). Ces données restent sur votre appareil et ne sont pas envoyées à nos serveurs.</p>
      <h3>4.2 Progressive Web App (PWA)</h3>
      <p>Si vous installez Lokaso comme application sur votre téléphone (PWA), des données de cache sont stockées localement pour permettre un accès plus rapide. Ces données ne contiennent aucune information personnelle identifiable.</p>

      <h2>5. Vos Choix et Droits</h2>
      <h3>5.1 Paramètres du navigateur</h3>
      <p>Vous pouvez configurer votre navigateur pour refuser tous les cookies ou vous alerter quand un cookie est envoyé. Notez que certaines fonctionnalités de Lokaso peuvent ne pas fonctionner correctement si vous désactivez les cookies nécessaires.</p>
      <ul>
        <li><strong>Chrome</strong> : Paramètres → Confidentialité → Cookies</li>
        <li><strong>Firefox</strong> : Paramètres → Vie privée → Cookies</li>
        <li><strong>Safari</strong> : Préférences → Confidentialité → Cookies</li>
        <li><strong>Android Chrome</strong> : Paramètres → Paramètres du site → Cookies</li>
      </ul>
      <h3>5.2 Opt-out Google Analytics</h3>
      <p>Pour vous opposer au suivi par Google Analytics, vous pouvez installer l'extension officielle : <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">tools.google.com/dlpage/gaoptout</a>.</p>
      <h3>5.3 Utilisateurs européens (RGPD)</h3>
      <p>Si vous accédez à Lokaso depuis l'Union Européenne ou l'Espace Économique Européen, un bandeau de consentement vous est présenté lors de votre première visite. Seuls les cookies strictement nécessaires sont actifs avant votre consentement.</p>

      <h2>6. Durées de Conservation Récapitulatives</h2>
      <ul>
        <li>Cookies de session : supprimés à la fermeture du navigateur</li>
        <li>Cookies d'authentification : 7 jours</li>
        <li>Google Analytics (_ga) : 2 ans</li>
        <li>Google Analytics (_gid) : 24 heures</li>
        <li>Consentement cookies (cc_cookie) : 6 mois</li>
      </ul>

      <h2>7. Mises à Jour de cette Politique</h2>
      <p>Nous pouvons mettre à jour cette politique pour refléter des changements dans nos pratiques ou pour des raisons légales. La date de dernière mise à jour est indiquée en haut du document. Nous vous encourageons à consulter cette page régulièrement.</p>

      <h2>8. Contact</h2>
      <ul>
        <li>Email : <a href="mailto:admin@lokasos.com">admin@lokasos.com</a></li>
        <li>WhatsApp : <a href="https://wa.me/12402859605">+1 240-285-9605</a></li>
        <li>Adresse : Conakry, République de Guinée</li>
      </ul>
    </LegalPage>
  );
}
